import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RescueStoreService {
  RESCATE_FONDS: any;
  RESCATE_BANKS: any;
  RESCATE_AGENTS: any;

  RESCATE_DATA:{
    cuc: string;
    cuotas: string;
    fechaSolicitud: string;
    formaPago: string;
    idCuentaBancaria: string;
    idCuentaParticipacion: string;
    idFondo: string;
    importe: string;
    rescateEnCuotas: string;
    rescateTotal: string;
    viaPago: string;
    codigoViaPagoid: string;
    activeAgent: boolean;
    agent: string;
    rut: string;
    idRut: string;
    codigo : string;
    tipoDocumento : string;
    numeroDocumento: string;
  }

  RESCATE_CONFIRM_DATA:{
    comisionCuotas: number,
    comisionEspecial: null,
    comisionEspecialCuotas: null,
    cuc: string;
    cuentaBancaria: {
      id: number, 
      codigoMoneda: string;
      tipoCuentaBancaria: string;
      numeroCuenta: string},
    cuentaParticipacion: {
      idCuentaParticipacion:number, 
      codigo: string, 
      etiqueta: string},
    diasFaltantesPlazo: number,
    fechaPago: string,
    fechaProcesoRescate: string,
    fechaProcesoValidacion: null,
    fechaSolicitudRescate: string,
    fechaSolicitudValidacion: null,
    flagAsociadoTraspasoFondo: null,
    flagCumplePlazoMinimoPermanencia: null,
    fondoAsociado: null,
    formaPago: string,
    fueConvertidoACuotas: string,
    igv: null,
    impuestoCuotas: null,
    impuestoEspecial: null,
    impuestoEspecialCuotas: null,
    isAnticipado: null,
    isSignificativo: string,
    monto: number,
    montoComisionAnticipada: null,
    montoNeto: number,
    numeroCuotas: number,
    participe: {
      id: string, 
      codigo: string, 
      razonSocial: string, 
      nombre1: string,
       nombre2: string},
    porcComisionAnticipado: boolean,
    porcentajeComisionAnticipado: null,
    rescateEnCuotas: string,
    rescateTotal: string,
    valorCuota: number | null,
    viaPago: string,
  }

  RESCATE_OPERATION: 
  {
    nroSolicitud: string
  }
  


  //
  constructor() {}
}
